export function hostnameToEnvironment(hostname: string) {
  if (hostname.includes('praxis-chat')) {
    return 'production';
  } else if (hostname.includes('localhost')) {
    return 'localhost';
  } else if (hostname.includes('testing')) {
    return 'testing';
  } else {
    return 'unknown';
  }
}

export const environment = hostnameToEnvironment(window.location.hostname);
